<template>
  <v-row>
    <v-col>
      <v-card>
        <v-toolbar dark color="primary">
          <v-row align-content="center">
            <v-col cols="10" class="text-left">
              <v-toolbar-title v-if="!enableFilters" class="textwithbackground--text">
                {{ $t('Доверенности пользователя') }}
              </v-toolbar-title>
            </v-col>
            <v-col class="text-right" align-self="center">
              <btn-icon-tip
                  id="addProxy"
                  icon="add"
                  icon-color="secondaryiconbtn"
                  :disabled="innerLoading"
                  :tip="$t('Добавить доверенность')"
                  @click="openAddProxyDialog" />
            </v-col>
          </v-row>
        </v-toolbar>
        <v-row class="px-2 pt-2">
          <v-col>
            <v-expansion-panels v-if="enableFilters">
              <v-expansion-panel v-test="{ panel: '' }">
                <v-expansion-panel-header>
                  <div id="search">
                    <v-icon>
                      search
                    </v-icon>
                    {{ $t('Фильтры') }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                  <v-row>
                    <v-col
                        cols="12"
                        sm="10"
                        md="5"
                        lg="4"
                        class="px-4">
                      <validatable-enum-combobox
                          v-model="params.status"
                          v-test="{ combobox: 'status' }"
                          clearable
                          :values-enum="STATUS_ENUM"
                          :label="$t('Статус доверенности')"
                          @change="focusOnBtn('searchBtn')" />
                    </v-col>
                    <v-col
                        cols="12"
                        sm="10"
                        md="5"
                        lg="4"
                        class="px-4">
                      <custom-date-picker
                          v-model="params.dateEnd"
                          v-test="{ date: 'dateEnd' }"
                          :label="$t('Дата завершения действия')"
                          @change="focusOnBtn('searchBtn')" />
                    </v-col>
                    <v-col
                        cols="2"
                        md="1"
                        class="text-right pr-4"
                        align-self="center">
                      <btn-icon-tip
                          id="search"
                          ref="searchBtn"
                          icon="search"
                          icon-color="info"
                          :tip="$t('Поиск')"
                          @click="search" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-card-text>
          <paginated-data-table
              v-if="getProxies"
              ref="paginatedTable"
              :headers="headers"
              :items="proxies"
              :loading="innerLoading"
              item-key="proxyId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              :request-method="getProxies">
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.number="{ item }">
              {{ item.number }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.file.fileName="{ item }">
              {{ item.file.fileName }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.dateBegin="{ item }">
              {{ item.dateBegin
                ? $moment(item.dateBegin).format('DD.MM.YYYY')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.dateEnd="{ item }">
              {{ item.dateEnd
                ? $moment(item.dateEnd).format('DD.MM.YYYY')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.contactPerson="{ item }">
              {{ item.contactPerson }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.notValidDate="{ item }">
              <icon-tip
                  :id="`notValidDate-${item.proxyId}`"
                  :icon="item.notValidDate
                    ? 'error_outline'
                    : 'check_circle_outline'"
                  :icon-color="item.notValidDate
                    ? 'error'
                    : 'success'"
                  :tip="$t('Документ {0} по датам.', [ $t(item.notValidDate
                    ? 'недействителен'
                    : 'действителен') ])" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.status="{ item }">
              <btn-icon-tip
                  v-if="canEdite"
                  :id="`editStatus-${item.status}-${item.proxyId}`"
                  icon="fiber_manual_record"
                  :icon-color="item.status === DOCUMENT_STATUSES.INPROCESS
                    ? 'info'
                    :(item.status === DOCUMENT_STATUSES.APPROVED)
                      ? 'success'
                      : 'error'"
                  :tip="`${$t('Изменить статус. Текущий:')} ${$t(STATUS_ENUM[item.status])}`"
                  @click="openStatusDialog(item.proxyId,
                                           item.status)" />
              <icon-tip
                  v-else
                  :icon-color="item.status === DOCUMENT_STATUSES.INPROCESS
                    ? 'info'
                    : (item.status === DOCUMENT_STATUSES.APPROVED)
                      ? 'success'
                      : 'error'"
                  :tip="$t('Текущий статус: {0}', [ $t(STATUS_ENUM[item.status]) ])"
                  icon="fiber_manual_record" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.file.fileId="{ item }">
              <btn-icon-tip
                  v-if="item.file.fileId"
                  :id="`getFile-${item.proxyId}`"
                  :tip="$t('Скачать документ')"
                  icon="get_app"
                  @click="getIdentityFile(item.file.fileId)" />
            </template>
          </paginated-data-table>
        </v-card-text>
        <add-proxy-dialog
            v-if="addProxyDialog.show"
            :dialog-prop="addProxyDialog"
            @close="closeDialog('addProxyDialog')" />
        <confirm-dialog
            v-if="statusDialog.show"
            :dialog-prop="statusDialog"
            @close="closeDialog('statusDialog')">
          <template v-slot:additional>
            <ValidationObserver ref="status">
              <validatable-enum-combobox
                  v-model="statusDialog.status"
                  v-test="{ combobox: 'proxyStatus' }"
                  rules="required"
                  :values-enum="STATUS_ENUM"
                  :label="$t('Статус сертификата')" />
            </ValidationObserver>
          </template>
        </confirm-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import CustomDatePicker from '@/components/reused/ui/CustomDatePicker.vue'
  import AddProxyDialog from './AddProxyDialog.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'
  import { STATUS_ENUM } from '@/constants/enums'
  import { DOCUMENT_STATUSES } from '@/constants/business'
  import { mapActions } from 'vuex'
  import { PROXIES_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      IconTip,
      ValidatableEnumCombobox,
      PaginatedDataTable,
      CustomDatePicker,
      AddProxyDialog,
      ConfirmDialog
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      proxies: {
        type: Array,
        default: () => {
          return []
        }
      },
      totalCount: {
        type: Number,
        require: true
      },
      proxyType: {
        type: String,
        require: true
      },
      documentGroup: {
        type: String,
        require: true
      },
      edited: {
        type: [Function, Promise],
        require: false
      },
      createMethod: {
        type: Function
      },
      canCreate: {
        type: Boolean,
        default: false
      },
      canEdite: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      enableFilters: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        DOCUMENT_STATUSES,
        STATUS_ENUM,
        itemsPerPage: 10,
        statusDialog: {
          show: false,
          status: null,
          proxyId: null,
          callback: null
        },
        addProxyDialog: {
          documentGroup: null,
          proxyType: null,
          show: false,
          callback: null
        },
        params: {
          dateEnd: '',
          status: ''
        }
      }
    },
    computed: {
      headers () {
        return [
          { text: this.$t('Доверенность'), sortable: false, value: 'file.fileName' },
          { text: this.$t('Дата начала действия'), sortable: false, value: 'dateBegin' },
          { text: this.$t('Дата завершения действия'), sortable: false, value: 'dateEnd' },
          { text: this.$t('ФИО доверенного лица'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Действительность'), sortable: false, value: 'notValidDate' },
          { text: this.$t('Статус'), sortable: false, value: 'status' },
          { text: this.$t('Действия'), sortable: false, value: 'file.fileId' }
        ]
      },
      innerLoading () {
        return this.loading || this.isLoading
      }
    },
    methods: {
      ...mapActions(PROXIES_MANAGEMENT.NAMESPACE, {
        changeProxyStatusAction: PROXIES_MANAGEMENT.ACTIONS.CHANGE_PROXY_STATUS
      }),
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getProxies: async function (params) {
        if (this.edited) {
          await this.edited({
            ...params,
            ...this.params
          })
        }
      },
      getProxiesList: async function () {
        await this.$refs.paginatedTable.getDataFromServer()
      },
      changeProxyStatus: async function () {
        try {
          this.isLoading = true
          await this.changeProxyStatusAction({
            proxyType: this.proxyType,
            status: this.statusDialog.status,
            proxyId: this.statusDialog.proxyId
          })
          await this.$refs.paginatedTable.getDataFromServer()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      // открыть окно подтверждения смены статуса доверенности
      openStatusDialog: function (proxyId, status) {
        this.statusDialog.proxyId = proxyId
        this.statusDialog.status = status
        this.statusDialog.callback = this.changeProxyStatus
        this.statusDialog.show = true
      },
      openAddProxyDialog: function () {
        this.addProxyDialog.callback = this.createMethod
        this.addProxyDialog.documentGroup = this.documentGroup
        this.addProxyDialog.proxyType = this.proxyType
        this.addProxyDialog.show = true
      }
    }
  }
</script>
